import { Box, CircularProgress, Paper } from '@mui/material';

export const SuggestionGenerationLoader = () => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: 0,
        left: 0,
        height: '100%',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: (theme) => theme.zIndex.modal,
      }}
    >
      <Paper
        elevation={4}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 1,
          padding: 2,
        }}
      >
        <CircularProgress size={24} />
        <Box>Generating response...</Box>
      </Paper>
    </Box>
  );
};
